import React, { useState, useEffect } from "react";
import axiosInstance from "../utils/axiosConfig";
import CircularProgress from "@mui/material/CircularProgress";
import io from 'socket.io-client';
import { FaRegSmileBeam, FaRegSadTear } from "react-icons/fa";
import { MdPhoneAndroid, email } from "react-icons/md";
import { FaWhatsapp } from "react-icons/fa";
import QRCode from "react-qr-code";
import axios from "axios";

const QrInfo = ({ qrData, 
  showCashback, 
  cashbackClaimed, 
  mobile, 
  redeemClaimed, 
  showRedeem,
  schemeStatusMessage
}) => {
  const [showModal, setShowModal] = useState(false);
  const [redeemId, setRedeemId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [amountRedeemed, setAmountRedeemed] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const [showDetails, setShowDetails] = useState(true);
  const [image, setImage] = useState(null);
  const [hasJustRedeemed, setHasJustRedeemed] = useState(false); // Track if user just redeemed

  const toggleDetails = () => {
    setShowDetails(!showDetails);
  };

  const productId = qrData?.product?.id;
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const fetchImage = async () => {
    if (!productId) return;
    try {
      const response = await axios.get(`${API_BASE_URL}/product-media/${productId}/image`);
      const {image} = response.data;
      setImage(image);
      console.log(image)
    } catch (error) {
      console.error("Error fetching product image:", error);
      return null;
    }
  }
  
  useEffect(() => {
    fetchImage();
    console.log("Fetched image for product ID:", productId);
  }, [productId]);

  if (!qrData) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <CircularProgress />
      </div>
    );
  }

  const { batch, product, cashback, scheme_id, scheme_data, company } = qrData;
  const { extra_fields: batchExtraFields } = batch;
  const { extra_fields: productExtraFields } = product;
  console.log(
    "QrInfo.js showRedeem:",
    showRedeem,
    "redeemClaimed:",
    redeemClaimed
  );
  console.log(qrData.cashback);

  const handleRedeemClick = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.post("/create-redeem", {
        mobile: mobile,
        company_id: product.company_id,
      });

      const receivedRedeemId = response.data.redeem_id;
      setRedeemId(receivedRedeemId);
      setShowModal(true);

      // Initialize socket connection
      const socket = io(process.env.REACT_APP_API_BASE_URL);

      // Listen for redeem result
      socket.on('redeem_result', (data) => {
        if (data.amount_redeemed) {
          setAmountRedeemed(data.amount_redeemed);
        } else if (data.msg) {
          setErrorMessage(data.msg);
          setTimeout(() => closeModal(), 3000);
        }
        socket.disconnect();
      });

      // Emit redeem search event
      socket.emit('redeem_search', { redeem_id: receivedRedeemId });

    } catch (error) {
      console.error("Error creating redeem ID:", error);
      setErrorMessage("Error creating redeem ID. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const closeModal = () => {
    // If redemption was successful, mark as redeemed
    if (amountRedeemed) {
      setHasJustRedeemed(true);
    }
    setShowModal(false);
    setRedeemId(null);
    setAmountRedeemed(null);
    setErrorMessage(null);
  };

  // Check if there's valid cashback to display
  const hasValidCashback = () => {
    if (!qrData.cashback) return false;
    if (typeof qrData.cashback === 'object') {
      return qrData.cashback.recently_earned > 0;
    }
    return qrData.cashback > 0;
  };

  return (
    <div className="bg-gray-200 min-h-screen flex flex-col items-center pt-4">
      {/* Cashback display div */}
      {showCashback && hasValidCashback() && !cashbackClaimed && !hasJustRedeemed && (
        <div className="w-full max-w-2xl mx-auto p-8 bg-gradient-to-br from-green-50 via-emerald-50 to-teal-50 shadow-2xl rounded-2xl mb-6 flex flex-col items-center justify-center border-4 border-green-200 relative overflow-hidden">
          {/* Celebration decorative elements */}
          <div className="absolute top-4 left-4 animate-bounce">
            <FaRegSmileBeam size={32} className="text-yellow-400 opacity-70" />
          </div>
          <div className="absolute top-4 right-4 animate-bounce" style={{ animationDelay: '0.2s' }}>
            <FaRegSmileBeam size={32} className="text-yellow-400 opacity-70" />
          </div>
          <div className="absolute bottom-4 left-8 animate-pulse">
            <span className="text-4xl">🎉</span>
          </div>
          <div className="absolute bottom-4 right-8 animate-pulse" style={{ animationDelay: '0.3s' }}>
            <span className="text-4xl">🎉</span>
          </div>
          
          {/* Animated coin emoji */}
          <div className="mb-3 animate-bounce">
            <span className="text-6xl">💰</span>
          </div>
          
          <h3 className="text-center text-3xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-green-600 to-emerald-600 mb-6 drop-shadow-sm">
            🎊 Cashback Available! 🎊
          </h3>
          
          {typeof qrData.cashback === 'object' ? (
            <>
              <div className="text-center mb-4 bg-white rounded-xl p-5 shadow-lg border-2 border-green-300 w-full max-w-sm">
                <div className="text-sm font-semibold text-green-700 mb-2 uppercase tracking-wide">Recently Earned</div>
                <div className="text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-green-600 animate-pulse">
                  ₹{qrData.cashback.recently_earned || 0}
                </div>
              </div>
              {qrData.cashback.previously_earned > 0 && (
                <div className="text-center mb-5 bg-gradient-to-r from-gray-50 to-gray-100 rounded-lg p-4 shadow-md border border-gray-300 w-full max-w-sm">
                  <div className="text-xs font-semibold text-gray-600 mb-1 uppercase tracking-wide">Previously Earned</div>
                  <div className="text-2xl font-bold text-gray-700">
                    ₹{qrData.cashback.previously_earned}
                  </div>
                </div>
              )}
            </>
          ) : (
            <div className="text-center mb-5 bg-white rounded-xl p-6 shadow-lg border-2 border-green-300">
              <div className="text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-green-600">
                ₹{qrData.cashback}
              </div>
            </div>
          )}
          
          <button
            onClick={handleRedeemClick}
            disabled={loading}
            className={`bg-gradient-to-r from-green-500 to-emerald-600 text-white px-8 py-4 rounded-full text-xl font-bold shadow-xl transform transition-all duration-200 ${
              loading ? 'opacity-50 cursor-not-allowed' : 'hover:scale-105 hover:shadow-2xl hover:from-green-600 hover:to-emerald-700'
            }`}
          >
            {loading ? '⏳ Processing...' : '🎁 Redeem Cashback Now'}
          </button>
        </div>
      )}

      {/* Cashback claimed message */}
      {showCashback && (cashbackClaimed || hasJustRedeemed) && (
        <div className="w-full max-w-2xl mx-auto p-6 bg-gradient-to-br from-red-50 to-orange-50 shadow-xl rounded-2xl mb-6 flex flex-col items-center justify-center border-2 border-red-200">
          <div className="mb-3">
            <span className="text-5xl">😔</span>
          </div>
          <h3 className="text-center text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-red-600 to-orange-600">
            Cashback Already Claimed
          </h3>
        </div>
      )}

      {/* Modal for showing redeem status */}
      {showModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 z-50 backdrop-blur-sm">
          <div className="bg-gradient-to-br from-white to-gray-50 p-8 rounded-2xl max-w-md text-center shadow-2xl border-2 border-green-200">
            {amountRedeemed ? (
              <>
                <div className="mb-4 animate-bounce">
                  <span className="text-6xl">🎉</span>
                </div>
                <h3 className="mb-4 text-2xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-green-600 to-emerald-600">
                  Cashback Redeemed Successfully!
                </h3>
                <div className="text-4xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-green-600 mb-4 animate-pulse">
                  ₹{amountRedeemed.recently_earned || amountRedeemed}
                </div>
                {amountRedeemed.previously_earned > 0 && (
                  <div className="text-sm font-semibold text-gray-600 mb-4 bg-gray-100 rounded-lg p-3">
                    Previously Earned: ₹{amountRedeemed.previously_earned}
                  </div>
                )}
                <button
                  onClick={closeModal}
                  className="bg-gradient-to-r from-blue-500 to-blue-600 text-white px-8 py-3 rounded-full font-bold shadow-lg hover:scale-105 transform transition-all duration-200 hover:shadow-xl"
                >
                  ✨ Close
                </button>
              </>
            ) : errorMessage ? (
              <>
                <div className="mb-4">
                  <span className="text-5xl">❌</span>
                </div>
                <h3 className="mb-4 text-xl font-bold text-red-600">Error</h3>
                <p className="text-gray-700 mb-4 bg-red-50 p-4 rounded-lg">{errorMessage}</p>
              </>
            ) : (
              <>
                <div className="mb-4">
                  <span className="text-5xl">⏳</span>
                </div>
                <h3 className="mb-4 text-lg font-bold text-gray-800">Processing Redemption...</h3>
                <div className="mb-4 bg-white p-4 rounded-lg shadow-inner">
                  <QRCode
                    value={redeemId || ""}
                    size={200}
                    className="mx-auto"
                  />
                </div>
                <p className="text-gray-600 mb-4 bg-gray-100 p-3 rounded-lg">Redeem ID: {redeemId}</p>
                <CircularProgress />
              </>
            )}
          </div>
        </div>
      )}

      {/* Top div: Scheme info, only if showRedeem is true */}
      {((showRedeem || redeemClaimed) && (qrData.scheme_data || schemeStatusMessage)) && (
        <div className="w-full max-w-2xl mx-auto p-8 bg-gradient-to-br from-purple-50 via-pink-50 to-rose-50 shadow-2xl rounded-2xl mb-6 flex flex-col items-center justify-center border-4 border-purple-200 relative overflow-hidden">
          {redeemClaimed ? (
            <>
              <div className="flex justify-center mb-4 animate-pulse">
                <FaRegSadTear size={64} className="text-blue-400" />
              </div>
              <h3 className="text-center text-2xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-red-600 to-pink-600">
                Scheme Already Claimed
              </h3>
            </>
          ) : (schemeStatusMessage || qrData.scheme_data?.message) ? (
            <>
              {/* Display message for inactive or expired schemes */}
              <div className="flex justify-center mb-4 animate-pulse">
                <FaRegSadTear size={64} className="text-blue-400" />
              </div>
              <h3 className="text-center text-2xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-orange-600 to-red-600">
                {schemeStatusMessage || qrData.scheme_data.message}
              </h3>
            </>
          ) : (
            <>
              {/* Celebration or Sad animation based on scheme_item_name */}
              <div className="flex justify-center mb-4 animate-bounce">
                {qrData.scheme_data?.scheme_item_name === "no-scheme" ? (
                  <FaRegSadTear size={64} className="text-blue-400" />
                ) : (
                  <FaRegSmileBeam size={64} className="text-yellow-400 drop-shadow-lg" />
                )}
              </div>
              {/* Hide congratulation and below details if no_scheme */}
              {qrData.scheme_data?.scheme_item_name !== "no-scheme" ? (
                <>
                  <h3 className="text-center text-3xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-green-600 to-emerald-600 mb-4">
                    🎊 CONGRATULATIONS! 🎊
                  </h3>
                  <div className="text-center text-lg text-gray-800 mb-4 bg-white rounded-xl p-4 shadow-md border-2 border-purple-200">
                    {qrData.scheme_data?.scheme_item_description}
                  </div>
                  <h5 className="text-center text-sm font-bold text-purple-700 mb-2 uppercase tracking-wide">
                    Docket Number
                  </h5>
                  <div className="text-center text-2xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-red-600 to-pink-600 mb-4 bg-white rounded-lg p-4 shadow-lg">
                    {qrData.scheme_data?.docket_no}
                  </div>
                  <div className="text-center text-sm text-gray-600 bg-yellow-50 rounded-lg p-3 border border-yellow-200">
                    📞 Contact company with the docket number for more details.
                  </div>
                </>
              ) : (
                <>
                  <div className="text-center text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-yellow-600 to-orange-600 mb-2">
                    Better Luck Next Time!
                  </div>
                </>
              )}
            </>
          )}
        </div>
      )}

      <div className="text-center mb-6 bg-gradient-to-r from-blue-50 to-indigo-50 p-6 rounded-2xl shadow-xl border-2 border-blue-200 w-full max-w-2xl mx-auto">
        <h1 className="text-2xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-indigo-600 mb-4">🔒 PRODUCT AUTHENTICATION 🔒</h1>
        <div className="flex items-center justify-center mt-3 bg-white rounded-xl p-4 shadow-lg">
          <img
            src={require("../Images/asli_utpad_logo.png")}
            alt="Logo"
            className="h-16 w-16 mr-3 drop-shadow-md"
          />
          <p className="text-xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-green-600 to-emerald-600">
            ✅ Thank you for purchasing Verified Product
          </p>
          <img
            src={require("../Images/verified_logo.png")}
            alt="Logo"
            className="h-16 w-16 ml-3 drop-shadow-md"
          />
        </div>
      </div>
      <div className="flex justify-center items-center mb-6 w-full max-w-2xl mx-auto">
        <div className="bg-white p-6 rounded-2xl shadow-2xl border-4 border-indigo-200">
        {image && image.image_file_data ? (
          <img
            src={`data:image/jpeg;base64,${image.image_file_data}`}
            alt="Product"
            className="max-w-full h-auto"
          />
        ) : (
          <div className="flex items-center justify-center h-48 bg-gray-100 rounded-xl">
            <span className="text-gray-400">Loading image...</span>
          </div>
        )}
        </div>
      </div>
      <div className="text-center mb-6">
        <h2 className="text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-indigo-600 to-purple-600 mb-2">{product.name}</h2>
        {/* <button
          onClick={toggleDetails}
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-full"
        >
          {showDetails ? "Hide Details" : "Show Details"}
        </button> */}
        {productId && <p className="text-xs text-gray-500">Product ID: {productId}</p>}
      </div>

      {/* Bottom div: Product info table, always visible */}
      {showDetails && (
        <div className="w-full max-w-2xl mx-auto p-6 bg-gradient-to-br from-white to-gray-50 shadow-2xl rounded-2xl border-2 border-indigo-200 overflow-x-auto">
        <table className="min-w-full text-xs sm:text-sm text-left text-gray-500 border-2 border-indigo-300 rounded-xl overflow-hidden">
            <thead className="text-xs bg-gradient-to-r from-indigo-600 to-purple-600 text-white uppercase">
              <tr>
                <th colSpan="2" className="px-6 py-4 text-center text-base font-bold tracking-wide">
                  📋 Product Information
                </th>
              </tr>
            </thead>
            <tbody>
              <tr className="bg-white border-b">
                <th className="px-3 py-2 sm:px-6 sm:py-4 font-medium text-gray-900 whitespace-normal break-words sm:whitespace-nowrap">
                  UID
                </th>
                <td className="px-3 py-2 sm:px-6 sm:py-4 text-xs sm:text-sm break-words">{qrData.uid}</td>
              </tr>
              <tr className="bg-white border-b">
                <th className="px-3 py-2 sm:px-6 sm:py-4 font-medium text-gray-900 whitespace-normal break-words sm:whitespace-nowrap">
                  Product Name
                </th>
                <td className="px-3 py-2 sm:px-6 sm:py-4 text-xs sm:text-sm break-words">{product.name}</td>
              </tr>
              <tr className="bg-white border-b">
                <th className="px-3 py-2 sm:px-6 sm:py-4 font-medium text-gray-900 whitespace-normal break-words sm:whitespace-nowrap">
                  Technical Name
                </th>
                <td className="px-3 py-2 sm:px-6 sm:py-4 text-xs sm:text-sm break-words">{product.technical_name}</td>
              </tr>
              <tr className="bg-white border-b">
                <th className="px-3 py-2 sm:px-6 sm:py-4 font-medium text-gray-900 whitespace-normal break-words sm:whitespace-nowrap">
                  Mfg. License No.
                </th>
                <td className="px-3 py-2 sm:px-6 sm:py-4 text-xs sm:text-sm break-words">
                  {qrData.company_data?.registration_no || "-"}
                </td>
              </tr>
              <tr className="bg-white border-b">
                <th className="px-3 py-2 sm:px-6 sm:py-4 font-medium text-gray-900 whitespace-normal break-words sm:whitespace-nowrap">
                  Product Registration Number
                </th>
                <td className="px-3 py-2 sm:px-6 sm:py-4 text-xs sm:text-sm break-words">
                  {qrData.product.cir_reg_no || "-"}
                </td>
              </tr>
              <tr className="bg-white border-b">
                <th className="px-3 py-2 sm:px-6 sm:py-4 font-medium text-gray-900 whitespace-normal break-words sm:whitespace-nowrap">
                  Batch Number
                </th>
                <td className="px-3 py-2 sm:px-6 sm:py-4 text-xs sm:text-sm break-words">{batch.batch_number}</td>
              </tr>
              <tr className="bg-white border-b">
                <th className="px-3 py-2 sm:px-6 sm:py-4 font-medium text-gray-900 whitespace-normal break-words sm:whitespace-nowrap">
                  Mfg Date
                </th>
                <td className="px-3 py-2 sm:px-6 sm:py-4 text-xs sm:text-sm break-words">{formatDate(batch.mfg_date)}</td>
              </tr>
              <tr className="bg-white border-b">
                <th className="px-3 py-2 sm:px-6 sm:py-4 font-medium text-gray-900 whitespace-normal break-words sm:whitespace-nowrap">
                  Exp Date
                </th>
                <td className="px-3 py-2 sm:px-6 sm:py-4 text-xs sm:text-sm break-words">{formatDate(batch.exp_date)}</td>
              </tr>
              <tr className="bg-white border-b">
                <th className="px-3 py-2 sm:px-6 sm:py-4 font-medium text-gray-900 whitespace-normal break-words sm:whitespace-nowrap">
                  Cautionary Symbol
                </th>
                <td className="px-6 py-4 flex items-center">
                  {product.cautionary_symbol ? (
                    <>
                      {/* Display image based on cautionary symbol value */}
                      {product.cautionary_symbol
                        .toLowerCase()
                        .includes("red") && (
                        <img
                          src={require("../Images/red.png")}
                          alt="Red Cautionary Symbol"
                          className="h-10 w-10"
                        />
                      )}
                      {product.cautionary_symbol
                        .toLowerCase()
                        .includes("blue") && (
                        <img
                          src={require("../Images/blue.png")}
                          alt="Blue Cautionary Symbol"
                          className="h-10 w-10"
                        />
                      )}
                      {product.cautionary_symbol
                        .toLowerCase()
                        .includes("yellow") && (
                        <img
                          src={require("../Images/yellow.png")}
                          alt="Yellow Cautionary Symbol"
                          className="h-10 w-10"
                        />
                      )}
                      {product.cautionary_symbol
                        .toLowerCase()
                        .includes("green") && (
                        <img
                          src={require("../Images/green.png")}
                          alt="Green Cautionary Symbol"
                          className="h-10 w-10"
                        />
                      )}
                    </>
                  ) : (
                    "-"
                  )}
                </td>
              </tr>
              {/* <tr className="bg-white border-b">
                <th className="px-3 py-2 sm:px-6 sm:py-4 font-medium text-gray-900 whitespace-normal break-words sm:whitespace-nowrap">
                  Cautionary Symbol
                </th>
                <td className="px-3 py-2 sm:px-6 sm:py-4 text-xs sm:text-sm break-words">
                  {product.cautionary_symbol || "-"}
                </td>
              </tr> */}
              <tr className="bg-white border-b">
                <th className="px-3 py-2 sm:px-6 sm:py-4 font-medium text-gray-900 whitespace-normal break-words sm:whitespace-nowrap">
                  Antidote Statement
                </th>
                <td className="px-3 py-2 sm:px-6 sm:py-4 text-xs sm:text-sm break-words">
                  {product.antidote_statement || "-"}
                </td>
              </tr>
              <tr className="bg-white border-b">
                <th className="px-3 py-2 sm:px-6 sm:py-4 font-medium text-gray-900 whitespace-normal break-words sm:whitespace-nowrap">
                  Manufactured by/Marketed by
                </th>
                <td className="px-3 py-2 sm:px-6 sm:py-4 text-xs sm:text-sm break-words">
                  {qrData.company_data?.name || "-"}
                </td>
              </tr>
              <tr className="bg-white border-b">
                <th className="px-3 py-2 sm:px-6 sm:py-4 font-medium text-gray-900 whitespace-normal break-words sm:whitespace-nowrap">
                  Customer Care No
                </th>
                <td className="px-3 py-2 sm:px-6 sm:py-4 text-xs sm:text-sm break-words">
                  {qrData.company_data?.customer_care_no || "-"}
                </td>
              </tr>
              <tr className="bg-white border-b">
                <th className="px-3 py-2 sm:px-6 sm:py-4 font-medium text-gray-900 whitespace-normal break-words sm:whitespace-nowrap">
                  Email
                </th>
                <td className="px-3 py-2 sm:px-6 sm:py-4 text-xs sm:text-sm break-words">
                  {qrData.company_data?.email || "-"}
                </td>
              </tr>
              {/* Add company extra fields if present */}
              {Array.isArray(qrData.company_data?.extra_field_company) &&
                qrData.company_data.extra_field_company.map((field, index) => (
                  <tr key={`company-extra-${index}`} className="bg-white border-b">
                    <th className="px-3 py-2 sm:px-6 sm:py-4 font-medium text-gray-900 whitespace-normal break-words sm:whitespace-nowrap">
                      {field.name || field.label}
                    </th>
                    <td className="px-3 py-2 sm:px-6 sm:py-4 text-xs sm:text-sm break-words">
                      {field.value || "-"}
                    </td>
                  </tr>
                ))}
              {/* Add extra fields if present */}
              {batchExtraFields &&
                Object.entries(batchExtraFields).map(([key, value]) => (
                  <tr key={key} className="bg-white border-b">
                    <th className="px-3 py-2 sm:px-6 sm:py-4 font-medium text-gray-900 whitespace-normal break-words sm:whitespace-nowrap">
                      {key}
                    </th>
                    <td className="px-3 py-2 sm:px-6 sm:py-4 text-xs sm:text-sm break-words">{value}</td>
                  </tr>
                ))}
              {productExtraFields &&
                Object.entries(productExtraFields).map(([key, value]) => (
                  <tr key={key} className="bg-white border-b">
                    <th className="px-3 py-2 sm:px-6 sm:py-4 font-medium text-gray-900 whitespace-normal break-words sm:whitespace-nowrap">
                      {key}
                    </th>
                    <td className="px-3 py-2 sm:px-6 sm:py-4 text-xs sm:text-sm break-words">{value}</td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      )}
      <div className="text-center mt-6 mb-8 bg-gradient-to-r from-teal-50 to-cyan-50 p-6 rounded-2xl shadow-xl border-2 border-teal-200 w-full max-w-2xl mx-auto">
        <h5 className="text-xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-teal-600 to-cyan-600 mb-3">📞 Customer Care</h5>
        <div className="bg-white rounded-xl p-4 shadow-lg flex justify-center items-center">
          <MdPhoneAndroid
            className="mr-3 animate-pulse"
            style={{ color: "#964B00" }}
            size={32}
          />
          <p className="text-2xl font-bold text-gray-800">{qrData.company_data?.customer_care_no || "-"}</p>
          <FaWhatsapp className="ml-3 animate-bounce" style={{ color: "#25D366" }} size={32} />
        </div>
      </div>
    </div>
  );
};


// Helper function to format date as DD/MM/YYYY
function formatDate(dateString) {
  if (!dateString) return "";
  const d = new Date(dateString);
  if (isNaN(d)) return dateString;
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  return `${day}/${month}/${year}`;
}

export default QrInfo;
